/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Yesterday_AtInputs */



/**
* | output |
* | --- |
* | "Yesterday at {time}" |
*
* @param {Yesterday_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const yesterday_at = /** @type {((inputs: Yesterday_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yesterday_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Yesterday at ${i?.time}`)
	return /** @type {LocalizedString} */ (`Hier à ${i?.time}`)
});